module.exports = __webpack_public_path__ + "static/media/  (42).a769c4c1.jpg";